import React from "react"
// Styles
import * as styles from "@/styles/modules/ColorBokeh.module.scss"

const ColorBokeh = props => {
  return (
    <div className={styles.wrapper}>
      <div />
      <div />
      <div />
    </div>
  )
}

export default ColorBokeh
